<template lang="pug">
  v-row.justify-center
    v-card
      v-card-text
        QrCode(:value="value" :size="250" level="H")
</template>

<script lang="ts">
import Vue from 'vue'
import { USER_LOGGED_IN } from '@/store/getter-types'
import QrCode from 'qrcode.vue'

export default Vue.extend({
  name: 'UserQR',

  components: {
    QrCode
  },

  methods: {

  },

  computed: {
    value (): string {
      return this.$store.getters[USER_LOGGED_IN].getBoarderQRCode
    },
  }
})
</script>

<style lang="stylus" scoped>

</style>
